import React, { Component } from 'react';
import { Button, ButtonToolbar, FormGroup, FormControl, ControlLabel, Modal, Form, HelpBlock } from 'react-bootstrap'
import Select from "react-select";

import { PropTypes } from 'prop-types';
import { MapPointStops } from "../mapPointStops/MapPointStops";

export class MapPointDraftForm extends Component {
    static contextTypes = {
        addEditionObserver: PropTypes.func,
        removeEditionObserver: PropTypes.func
    }

    constructor(props) {
        super(props);

        this.state = {
            render: {
                showStopsForm: false
            },
            networkEditions: []
        };
    }

    componentDidMount() {
        this.context.addEditionObserver(this);
    }

    componentWillUnmount() {
        this.context.removeEditionObserver(this);
    }

    // ----------------------

    updateDraftNetwork(edition) {
        this.setState({
            networkEditions: edition.objects.draftNetwork
        });
    }


    // ---------------------

    onRemoveSelectedStopValue(e) {
        const { stops } = this.props;
        
        const mappedStop = stops.filter(stop => stop.id === e);
        if(undefined === mappedStop) {
            return;
        }

        this.props.onRemoveSelectValue(e, "stops");

    }

    onShowStopsForm() {
        const { render } = this.state;

        render.showStopsForm = true;

        this.setState({
            render: render
        });
    }

    onHideStopsForm() {
        const { render } = this.state;

        render.showStopsForm = false;

        this.setState({
            render: render
        });
    }

    // ---------------------

    renderEditionFormGroup(formType, mapPoint) {
        const { networkEditions } = this.state;

        if ("create" === formType) {
            return (
                <FormGroup controlId="formEdition">
                    <ControlLabel>Edição</ControlLabel>
                    <Select
                        className="custom-multiselect"
                        placeholder="Selecione uma edição..."
                        noOptionsMessage={() => "Sem Edições Configuradas"}
                        onChange={(e) => this.props.onSelectValue(null === e ? undefined : e.id, "networkEdition")}
                        options={networkEditions}
                        isMulti={false}
                        isClearable={true}
                        getOptionValue={value => value.id}
                        getOptionLabel={label => label.name}
                        value={networkEditions.find(nEdition => nEdition.id === mapPoint.networkEdition)}
                    />
                </FormGroup>
            );
        }

        return null;
    }

    render() {
        const { form } = this.props;

        if (undefined === form) {
            return null;
        }

        const { show, interfaces, stops } = this.props;
        const { render } = this.state;

        return (
            <Modal show={show}>
                <Modal.Header>
                    <Modal.Title>
                        {form.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        {this.renderEditionFormGroup(form.type, form.obj)}

                        <FormGroup controlId="formName" validationState={form.nameInputError}>
                            <ControlLabel>Nome</ControlLabel>
                            <FormControl
                                type="text"
                                value={form.obj.name}
                                placeholder="Introduza o nome"
                                onChange={(e) => this.props.onChangeValue(e, "name")}
                            />
                            {form.nameInputError !== null
                                ?
                                <HelpBlock> Este campo não pode estar vazio. </HelpBlock>
                                :
                                null
                            }
                        </FormGroup>

                        <FormGroup controlId="formLatitude" validationState={form.latitudeInputError}>
                            <ControlLabel>Latitude</ControlLabel>
                            <FormControl
                                type="number"
                                value={form.obj.latitude}
                                placeholder="Introduza a Latitude"
                                onChange={(e) => this.props.onChangeValue(e, "latitude")}
                            />
                            {form.latitudeInputError !== null
                                ?
                                <HelpBlock> Este campo não pode estar vazio. </HelpBlock>
                                :
                                null
                            }
                        </FormGroup>

                        <FormGroup controlId="formLongitude" validationState={form.longitudeInputError}>
                            <ControlLabel>Longitude</ControlLabel>
                            <FormControl
                                type="number"
                                value={form.obj.longitude}
                                placeholder="Introduza a Longitude"
                                onChange={(e) => this.props.onChangeValue(e, "longitude")}
                            />
                            {form.longitudeInputError !== null
                                ?
                                <HelpBlock> Este campo não pode estar vazio. </HelpBlock>
                                :
                                null
                            }
                        </FormGroup>

                        <FormGroup controlId="formAddInfo">
                            <ControlLabel>Informação Adicional</ControlLabel>
                            <FormControl
                                type="text"
                                value={form.obj.addInfo}
                                placeholder="Introduza a informação adicional"
                                onChange={(e) => this.props.onChangeValue(e, "addInfo")}
                            />
                        </FormGroup>

                        <FormGroup controlId="formInterfaces">
                            <ControlLabel>Interfaces</ControlLabel>
                            <Select
                                className="custom-multiselect"
                                placeholder="Sem Interfaces"
                                noOptionsMessage={() => "Sem Interfaces Configuradas"}
                                onChange={(e) => this.props.onSelectValue(e, "interfaces")}
                                options={interfaces}
                                isMulti={true}
                                isOptionSelected={function (a) {
                                    if (undefined !== form.obj.interfaces) {
                                        return form.obj.interfaces.includes(a.id);
                                    }
                                }}
                                getOptionValue={value => value.id}
                                getOptionLabel={label => label.namePt}
                                value={form.obj.interfaces}
                            />
                        </FormGroup>
                    </Form>

                    <ButtonToolbar>
                        <Button onClick={() => this.onShowStopsForm()}> GERIR PARAGENS ASSOCIADAS </Button>
                        <Button onClick={() => this.props.onCalculateCoordinates()} disabled={form.obj.stops.length === 0}> CALCULAR COORDENADAS </Button>
                        <Button className="btns-two-lines-small-screens-inside-modal" onClick={() => this.props.onSave()}> GUARDAR ALTERAÇÕES </Button>
                        <Button className="margin-top-10 btns-two-lines-small-screens-inside-modal" onClick={() => this.props.onHide()}> CANCELAR </Button>
                    </ButtonToolbar>

                    <MapPointStops
                        show={render.showStopsForm}
                        onChangeStopValue={(a) => this.props.onSelectValue(a, "stops")}
                        onRemoveSelectedStopValue={(a) => this.onRemoveSelectedStopValue(a, "stops")}
                        mapPoint={form.obj}
                        stops={stops}
                        onHide={() => this.onHideStopsForm()} />
                </Modal.Body>
            </Modal >
        );
    }
}
